<template>
  <div class="iframe-wrpper">
    <iframe ref="iframe" :src="externalSrc"></iframe>
  </div>
</template>
<style lang="stylus" scoped>
.iframe-wrpper
  height 100%
  width 100%

  iframe
    border none
    height 100%
    width 100%
</style>
<script>
export default {
  name: 'external',
  data() {
    return {
      window: null
    }
  },
  computed: {
    externalSrc() {
      return this.$route.query.externalSrc
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.window = this.$refs.iframe.currentWindow
    })
  }
}
</script>